// Amounts are integer cents everywhere; formatting is Italian ("1.284,50 €").

// Italian locale data omits the separator below 10.000 ("1530,00 €"): always group, so columns read alike.
const euro = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  useGrouping: 'always',
});
const euroRounded = new Intl.NumberFormat('it-IT', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
  useGrouping: 'always',
});

export function formatCents(cents: number, options: { signed?: boolean; round?: boolean } = {}) {
  const formatter = options.round ? euroRounded : euro;
  const text = formatter.format(Math.abs(cents) / 100);
  if (cents < 0) return `−${text}`;
  if (options.signed && cents > 0) return `+${text}`;
  return text;
}

/**
 * Reads what people type: "12", "12,5", "12.50", "1.234,56", "€ 1 234". Returns cents, or null
 * if it is not a positive amount.
 */
export function parseAmount(input: string): number | null {
  let text = input.replace(/[€\s]/g, '');
  if (!text) return null;
  if (text.includes(',')) {
    text = text.replaceAll('.', '').replace(',', '.');
  } else if (/^\d{1,3}(\.\d{3})+$/.test(text)) {
    text = text.replaceAll('.', '');
  }
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return null;
  const cents = Math.round(Number(text) * 100);
  return cents > 0 ? cents : null;
}

/** Cents → the editable text shown in an input ("12,50"). */
export function centsToInput(cents: number): string {
  return (Math.abs(cents) / 100).toFixed(2).replace('.', ',');
}
